
import styles from '../coverSection/coverSection.module.css';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';

export function CoverSection() {
  return (
    <section className={styles.coverContainer}>
      <MarkupLayout>
        <div className={styles.coverTextContainer}>
          <h2 className={styles.coverHeader}>о нас</h2>
          <div className={styles.coverInfoContainer}>
            <div className={styles.coverInfoContainerItem}>
              <p className={styles.coverInfoContainerText}>&gt;25</p>
              <p>Лет работы</p>
            </div>
            <div className={styles.coverInfoContainerItem}>
              <p className={styles.coverInfoContainerText}>30000+</p>
              <p>Клиентов</p>
            </div>
            <div className={styles.coverInfoContainerItem}>
              <p className={styles.coverInfoContainerText}>20</p>
              <p>Дилеров</p>
            </div>
          </div>
          {/* <p className={styles.coverParagraph}>
            Воздушные фильтры очищают воздух, поступающий в двигатель, от частиц пыли и других
            загрязнений. Чистый воздух улучшает качество процесса сгорания топлива и обеспечивает
            оптимальную производительность двигателя. Воздушные фильтры особенно важны
          </p> */}
        </div>
      </MarkupLayout>
    </section>
  );
}
